export default __webpack_public_path__ + "static/media/Skipio-Demo.aa329526.gif";